<div class="otp-dialog" dir="rtl">
  <!-- Header -->
  <div class="otp-dialog__header">
    <span class="otp-dialog__icon" [class.is-ok]="phase === 'verified'" aria-hidden="true">
      @if (phase === 'verified') {
        <svg viewBox="0 0 24 24"><path d="M9 16.2 4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4z"/></svg>
      } @else {
        <svg viewBox="0 0 24 24"><path d="M17 1H7C5.9 1 5 1.9 5 3v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 18H7V5h10v14zm-5 3c-.8 0-1.5-.7-1.5-1.5S11.2 19 12 19s1.5.7 1.5 1.5S12.8 22 12 22z"/></svg>
      }
    </span>
    <div class="otp-dialog__heading">
      <h2 class="otp-dialog__title">אימות מספר טלפון</h2>
      <p class="otp-dialog__subtitle">
        @if (phase === 'sending' && !codeSent) {
          שולחים קוד אימות למספר
        } @else {
          הזינו את הקוד בן 6 הספרות שנשלח למספר
        }
        <bdi class="otp-dialog__phone" dir="ltr">{{ maskedPhone }}</bdi>
      </p>
    </div>
    <button type="button" class="otp-dialog__close" (click)="close()" [disabled]="phase === 'verifying'" aria-label="סגירה">
      <svg viewBox="0 0 24 24"><path d="M19 6.4 17.6 5 12 10.6 6.4 5 5 6.4 10.6 12 5 17.6 6.4 19 12 13.4 17.6 19 19 17.6 13.4 12z"/></svg>
    </button>
  </div>

  @if (linkedMessage) {
    <div class="otp-dialog__body otp-dialog__linked" role="alert">
      <div class="otp-dialog__linked-badge" aria-hidden="true">
        <svg viewBox="0 0 24 24"><path d="M12 12c2.2 0 4-1.8 4-4s-1.8-4-4-4-4 1.8-4 4 1.8 4 4 4zm0 2c-2.7 0-8 1.3-8 4v2h9.5a6.5 6.5 0 0 1-.4-6H12zm7.1.5-1.4-1.4-2.1 2.1-2.1-2.1-1.4 1.4 2.1 2.1-2.1 2.1 1.4 1.4 2.1-2.1 2.1 2.1 1.4-1.4-2.1-2.1z"/></svg>
      </div>
      <h3>המספר מקושר לחשבון אחר</h3>
      <p>{{ linkedMessage }}</p>
      <p class="otp-dialog__linked-phone"><bdi dir="ltr">{{ maskedPhone }}</bdi></p>
    </div>
    <div class="otp-dialog__footer">
      <button type="button" class="otp-btn otp-btn--ghost" (click)="changeNumber()">שינוי מספר</button>
      <div class="otp-dialog__primary">
        <button type="button" class="otp-btn otp-btn--primary" (click)="switchAccount()">התחברות לחשבון הנכון</button>
      </div>
    </div>
  } @else if (phase === 'verified') {
    <div class="otp-dialog__body otp-dialog__done">
      <div class="otp-dialog__done-badge" aria-hidden="true">
        <svg viewBox="0 0 24 24"><path d="M9 16.2 4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4z"/></svg>
      </div>
      <h3>המספר אומת בהצלחה</h3>
      <p>אפשר להמשיך לבחירת מסלול הפרסום</p>
    </div>
  } @else {
    <div class="otp-dialog__body">
      <!-- Code -->
      <label class="otp-dialog__label" for="otpCode">קוד אימות</label>
      <input #codeInput
             id="otpCode"
             class="otp-dialog__code"
             [class.is-error]="!!codeError"
             [@shakeit]="shakeState"
             [value]="code"
             (input)="onCodeInput($any($event.target).value)"
             (keydown.enter)="verify()"
             [disabled]="!codeSent || locked || phase === 'verifying'"
             inputmode="numeric"
             autocomplete="one-time-code"
             maxlength="6"
             dir="ltr"
             placeholder="••••••"
             type="text" />

      <div class="otp-dialog__meta">
        @if (codeError) {
          <span class="otp-msg otp-msg--error" role="alert">{{ codeError }}</span>
        } @else if (sendError) {
          <span class="otp-msg otp-msg--error" role="alert">{{ sendError }}</span>
        } @else if (phase === 'sending') {
          <span class="otp-msg"><span class="otp-spinner"></span> שולחים קוד…</span>
        } @else if (info) {
          <span class="otp-msg otp-msg--info">{{ info }}</span>
        }
        @if (codeSent && !locked) {
          <span class="otp-attempts" [class.is-low]="attemptsLeft <= 3">
            נותרו {{ attemptsLeft }} מתוך {{ maxAttempts }} ניסיונות
          </span>
        }
      </div>

      <!-- Resend -->
      <div class="otp-resend">
        <span class="otp-resend__q">לא קיבלתם קוד?</span>
        @if (limitWait > 0 || sendsLeft === 0) {
          <span class="otp-resend__wait">
            @if (limitWait > 0) { ניתן לבקש קוד חדש בעוד {{ formatTime(limitWait) }} } @else { הגעתם למגבלת השליחות }
          </span>
        } @else if (cooldown > 0) {
          <span class="otp-resend__wait">
            <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm0 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm.5-13H11v6l5.2 3.2.8-1.3-4.5-2.7z"/></svg>
            שליחה חוזרת בעוד <b dir="ltr">{{ formatTime(cooldown) }}</b>
          </span>
        } @else {
          <button type="button" class="otp-resend__btn" (click)="sendCode()" [disabled]="!canResend">
            שלחו לי קוד חדש
          </button>
        }
        @if (sendsLeft !== null && sendsLeft > 0) {
          <span class="otp-resend__left">({{ sendsLeft }} שליחות נותרו ב-3 השעות הקרובות)</span>
        }
      </div>

      <!-- Consents -->
      <div class="otp-consents">
        <label class="consent-option"
               [class.is-checked]="acceptTerms"
               [class.is-disabled]="termsLocked"
               (click)="onTermsClick($event)">
          <input class="consent-input" type="checkbox"
                 [disabled]="termsLocked"
                 [ngModel]="acceptTerms"
                 (ngModelChange)="onTermsChange($event)" />
          <span class="consent-control" aria-hidden="true">
            <svg viewBox="0 0 20 20"><path d="M4.5 10.2l3.2 3.2 7.8-7.8"></path></svg>
          </span>
          <span class="consent-text">קראתי ואישרתי את <a href="#" class="terms-link" (click)="openTerms($event)">התקנון</a></span>
        </label>
        <label class="consent-option"
               [class.is-checked]="acceptAdv"
               [class.is-disabled]="!acceptTerms">
          <input class="consent-input" type="checkbox"
                 [disabled]="!acceptTerms"
                 [ngModel]="acceptAdv"
                 (ngModelChange)="onAdvChange($event)" />
          <span class="consent-control" aria-hidden="true">
            <svg viewBox="0 0 20 20"><path d="M4.5 10.2l3.2 3.2 7.8-7.8"></path></svg>
          </span>
          <span class="consent-text">אני רוצה לקבל עדכונים רלוונטיים למודעה שלי במייל</span>
        </label>
      </div>
    </div>

    <!-- Footer -->
    <div class="otp-dialog__footer">
      <button type="button" class="otp-btn otp-btn--ghost" (click)="close()" [disabled]="phase === 'verifying'">ביטול</button>
      <div class="otp-dialog__primary">
        <button type="button" class="otp-btn otp-btn--primary" (click)="verify()" [disabled]="!canVerify">
          @if (phase === 'verifying') { <span class="otp-spinner otp-spinner--light"></span> מאמתים… } @else { אימות מספר }
        </button>
        @if (verifyHint) { <span class="otp-dialog__hint">{{ verifyHint }}</span> }
      </div>
    </div>
  }
</div>
